import { Radio } from 'antd'
import { CheckboxOptionType } from 'antd/es/checkbox/Group'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import styles from './pure-radio.module.scss'

import dismiss = toast.dismiss

type RadioProps = {
  style?: any
  // TODO fix
  value: any
  label?: string
  placeholder?: string
  colClass?: string
  moduleStyle?: string
  icon?: React.ReactNode
  name?: string
  error?: string | string[]
  required?: boolean
  size?: SizeType
  type?: string
  className?: string
  disabled?: boolean
  options?: CheckboxOptionType[]
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const PureRadio: React.FC<RadioProps> = ({
  value,
  label,
  colClass,
  moduleStyle,
  error,
  required = true,
  className = '',
  options,
  disabled,
}) => {
  const [valueInState, setValue] = useState(null)

  useEffect(() => {
    setValue(value)
  }, [value])

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.inputStyles, className)}>
      {label ? (
        <div className="label d-block mt-2 mb-1 fs-6">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <Radio.Group
        className={clsx('d-flex', 'flex-column')}
        onChange={(e) => setValue(e.target.value)}
        value={valueInState}
      >
        {options?.map((option) => (
          <Radio
            key={option.value}
            disabled={disabled}
            value={option.value}
          >
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
      {error ? <div className="error-message">{error}</div> : null}
    </div>
  )
}
